<template>
    <a
        :href="getBrandLink() | appendfragment('cta', 'brand_product_review_footer_cta')"
        rel="nofollow"
        class="play_now_btn visit_btn exit-page-link"
        target="_blank"
        :data-gtm="'brandproduct-footer-cta-' + brand.brand + '-state ' + state.toLowerCase()"
        data-kt="cta:a|ctalocation|operator|product|brand_id|brand_product_id"
        data-ctalocation="brand product review footer cta"
        :data-operator="brand.brand"
        :data-product="brand.brand + ' ' + brandProduct.product_type"
        :data-brand_id="brand.id"
        :data-brand_product_id="brandProduct.brand_product_id"
        style="text-transform: uppercase"
        v-html="getBrandLabel()"
        v-if="getBrandLink()"
    >
    </a>
</template>

<script>
export default {
    name: 'content-button',
    props: {
        id: {
            type: Number,
            required: true,
        },
        brand: {
            type: Object,
            required: true,
        },
        brandProduct: {
            type: Object,
            default: false,
        },
        offers: {
            type: Array,
            default: false,
        },
        geo: {
            type: String,
        },
        defaultRegion: {
            type: String,
        },
    },
    data() {
        return {
            product: {},
            offer: {},
            validDestinationLink: false,
            cookieKey: 'op_list_region_' + this.geo.toLowerCase(),
        };
    },
    created() {
        var self = this;

        // Fire KTAG tracking event
        setTimeout(function () {
            ktag.reRender();
        }, 500);

        // Listen for a state change
        $('body').on('vueOpList:setState', function (e, state, scope) {
            // Update the link
            if (scope != this.scope) {
                self.state = state;
                self.getProductAndOffer();
            }
        });

        // Check to see if we have a cookie set
        if ($cookies.isKey(this.cookieKey)) {
            this.state = $cookies.get(this.cookieKey);
        } else {
            this.state = this.defaultRegion;
        }

        this.getProductAndOffer();
    },
    methods: {
        getProductAndOffer() {
            var self = this;

            this.product = {};
            this.offer = {};

            self.product = this.brandProduct

            self.offer = self.offers.find((offer) => {
                return offer.us_states.some((state) => state.code == self.state);
            });

            if (!self.offer) {
                if (this.geo == 'CA') {
                    // Fallback to Ontario for CA
                    self.offer = self.offers.find((offer) => {
                        return offer.us_states.some((state) => state.code == 'AB');
                    });
                } else {
                    self.offer = this.offers[0];
                }
            }
        },
        getBrandLink() {
            if (this.offer && Object.keys(this.offer).length !== 0) {
                return this.offer.exit_link;
            }
            return false;
        },
        getBrandLabel() {
            return 'Visit ' + this.brand.brand + '<span class="icon-play"></span>';
        }
    },
};
</script>
